/* eslint-disable */
import {
    Card,
    CardContent,
    Grid,
    RACRadio,
    Typography,
} from '@rentacenter/racstrap';
import React, { useContext, useEffect, useState } from 'react';
import { CostBasedPricingStyles } from '../Styles/CostBasedPricing';
import { ReactComponent as RightAngle } from '../../../assets/images/angleRight.svg';
import { PricingQueueContext } from './PricingQueueContext';

export default function CostBasedPricingApproval(props: any) {
    const classes = CostBasedPricingStyles();
    const {
        costBasedPricingApprovalData, setCostBasedPricingApprovalData,
        indexValue, setHideMainPage, comments, setComments, setIsPackage,
    } = useContext(PricingQueueContext);

    const formatDate = (dateStr: string) => {
        const [year, month, day] = dateStr.split('-');
        return `${month}/${day}/${year}`;
    };
    function returnValue(value: string | null, type?: any) {
        return value ? `$${value}` : '-'
    }
    function returnDecimelValue(value: string | null, type?: any) {
        return value ? parseFloat(value).toString() : '-'
    }
    useEffect(() => {
        console.log(indexValue, 'indexValue in indexValue')
        if (indexValue && indexValue.costBasedRules) {
            const ruleData = indexValue.costBasedRules;
            const updatedData = {
                zone: ruleData.zone[0] || '-',
                department: ruleData.departmentName || '-',
                subdepartment: ruleData.subdepartmentName || '-',
                bracket: ruleData.bracketName || '-',
                startDate: formatDate(ruleData.startDate) || '-',
                endDate: formatDate(ruleData.endDate) || '-',
                publishPriceForExisitingRMS: ruleData.publishPriceFlag || '-',
                publishPriceWhenCostChanges: ruleData.publishOnCostChangeFlag || '-',
                schedule: indexValue.schedule || '-',
                minRatePct: returnDecimelValue(ruleData.minRatePct) || '-',
                maxRatePct: returnDecimelValue(ruleData.maxRatePct) || '-',
                minRateNew: returnValue(ruleData.minRateNew) || '-',
                maxRateNew: returnValue(ruleData.maxRateNew) || '-',
                minRateUsed: returnValue(ruleData.minRateUsed) || '-',
                maxRateUsed: returnValue(ruleData.maxRateUsed) || '-',
                turns: returnDecimelValue(ruleData.turn) || '-',
                termMax: ruleData.maxTerm || '-',
                initialAmount: returnDecimelValue(ruleData.initAmount) || '-',
                growth: returnDecimelValue(ruleData.growth) || '-',
                lineShiftLr: returnDecimelValue(ruleData.lineShiftLR) || '-',
                lineShiftUd: returnDecimelValue(ruleData.lineShiftUD) || '-',
                usedRateAdjustment: returnValue(ruleData.usedRateAdj) || '-'
            };
            setCostBasedPricingApprovalData(updatedData);
        }
    }, [])



    function breadCrums() {
        return (
            <>
                <Typography variant='body1' className={`${classes.greyColor} ${classes.fs12} ${classes.cursorStyle}`}>
                    <span onClick={() => {
                        setHideMainPage(false);
                        setComments('');
                        setIsPackage(false);
                    }}> Pricing Queue </span>
                    <span className={`${classes.ml10}`}><RightAngle className={`${classes.h10}`} style={{ color: 'grey' }} /></span>
                    <span className={`${classes.ml10} ${classes.cursorStyle} ${classes.textBlue}`}
                    > Cost Based Pricing Approval </span>
                </Typography>
            </>
        )
    }

    return (
        <>
            <Grid container md={12} className={`${classes.pagePadding1}`}>
                <Grid container md={12} style={{ marginBottom: '15px' }}>
                    {breadCrums()}
                </Grid>
                <Grid container style={{ width: '100%' }}>
                    <Grid container style={{ width: '47%', marginRight: '1%' }}>
                        <Grid item md={12} style={{ marginBottom: '10px' }}>
                            <Typography variant='h4'>Cost Based Pricing Approval</Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Card className={classes.card} style={{ height: '71vh', overflowY: 'auto' }}>
                                <CardContent style={{ paddingRight: '0px', padding: '3%' }}>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '5px' }}>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Zone</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.zone}</Typography>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Department</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.department}</Typography>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Sub Department</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.subdepartment}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '5px' }}>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Bracket</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.bracket}</Typography>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Start Date</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.startDate}</Typography>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>End Date</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.endDate}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} style={{ marginBottom: '5px' }}>
                                        <Grid item md={12}>
                                            <span className={classes.title6}>Do you want to generate new price for existing RMS items?</span>
                                            <Grid style={{ margin: '1%' }}>
                                                <RACRadio
                                                    value={''}
                                                    checked={(costBasedPricingApprovalData?.publishPriceForExisitingRMS)?.toUpperCase() == 'YES'}
                                                    label="Yes (Generate new price to existing and future RMS items)"
                                                    name="existingRMS"
                                                    disabled={true}
                                                />
                                                <RACRadio
                                                    value={''}
                                                    checked={(costBasedPricingApprovalData?.publishPriceForExisitingRMS)?.toUpperCase() == 'NO'}
                                                    label="No (Generate new price only to future RMS items)"
                                                    name="existingRMS"
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} style={{ marginBottom: '5px' }}>
                                        <Grid item md={12}>
                                            <span className={classes.title6}>Do you want to generate new price when the purchase cost changes?</span>
                                            <Grid style={{ margin: '1%' }}>
                                                <RACRadio
                                                    value={''}
                                                    checked={(costBasedPricingApprovalData?.publishPriceWhenCostChanges)?.toUpperCase() == 'YES'}
                                                    label="Yes"
                                                    name="purchaseCost"
                                                    disabled={true}
                                                />
                                                <RACRadio
                                                    value={''}
                                                    checked={(costBasedPricingApprovalData?.publishPriceWhenCostChanges)?.toUpperCase() == 'NO'}
                                                    label="No"
                                                    name="purchaseCost"
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} style={{ marginBottom: '5px' }}>
                                        <Grid item md={12}>
                                            <span className={classes.title6}>How do you want to update the Cost Based Pricing?</span>
                                            <Grid style={{ margin: '1%' }}>
                                                <RACRadio
                                                    value={''}
                                                    checked={costBasedPricingApprovalData?.schedule == 'IMMEDIATE'}
                                                    label="Immediately"
                                                    name="schedule"
                                                    disabled={true}
                                                />
                                                <RACRadio
                                                    value={''}
                                                    checked={costBasedPricingApprovalData?.schedule == 'OVERNIGHT'}
                                                    label="Overnight"
                                                    name="schedule"
                                                    disabled={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12}>
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <span className={classes.title6}>Comments</span>
                                            <Grid item>
                                                <textarea
                                                    rows={6}
                                                    style={{ resize: "none", width: "100%", border: "1px solid lightgray !important" }}
                                                    disabled={
                                                        indexValue?.status?.toUpperCase() == "QUEUED" ||
                                                            indexValue?.status?.toUpperCase() == "WAITING"
                                                            ? false
                                                            : true
                                                    }
                                                    value={comments}
                                                    onChange={(e: any) => {
                                                        setComments(e.target.value);
                                                    }}
                                                ></textarea>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <Grid container style={{ width: '52%' }}>
                        <Grid item md={12} style={{ marginBottom: '10px' }}>
                            <Typography variant='h4'>Cost Based Foundation Rules</Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Card className={classes.card} style={{ height: '71vh', overflowY: 'auto' }}>
                                <CardContent style={{ paddingRight: '0px', padding: '3%' }}>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '20px' }}>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Min Rate %</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.minRatePct}</Typography>
                                        </Grid>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Max Rate %</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.maxRatePct}</Typography>
                                        </Grid>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Min Rate (NEW)</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.minRateNew}</Typography>
                                        </Grid>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Max Rate (NEW)</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.maxRateNew}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '20px' }}>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Min Rate (USED)</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.minRateUsed}</Typography>
                                        </Grid>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Max Rate (USED)</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.maxRateUsed}</Typography>
                                        </Grid>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Turns</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.turns}</Typography>
                                        </Grid>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Term Max</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.termMax}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '20px' }}>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Initial Amount (A)</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.initialAmount}</Typography>
                                        </Grid>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Growth (r)</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.growth}</Typography>
                                        </Grid>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Line Shift LR (m)</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.lineShiftLr}</Typography>
                                        </Grid>
                                        <Grid item md={3}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Line Shift UD (k)</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.lineShiftUd}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '20px' }}>
                                        <Grid item md={4}>
                                            <Typography style={{ fontFamily: 'OpenSans-bold' }}>Used Rate Adjustment (y)</Typography>
                                            <Typography style={{ fontFamily: 'OpenSans-regular' }}>{costBasedPricingApprovalData.usedRateAdjustment}</Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}
